var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.81,282.537c0-0.065,0.065-0.065,0.065-0.129c-0.065-1.745-0.259-3.491-0.259-5.236 c0-63.677,51.782-115.459,115.459-115.459c1.745,0,3.491,0.129,5.236,0.259c0.065,0,0.129-0.065,0.259-0.065 c0.259-3.168,0.323-6.335,0.323-9.438c0-71.952-58.57-130.521-130.521-130.521C74.667,21.818,22.432,86.4,21.786,152.339 c0.129,78.675,63.741,130.521,130.521,130.521C155.475,282.925,158.642,282.796,161.81,282.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M370.747,277.107c0-51.588-42.02-93.673-93.673-93.673s-93.673,42.02-93.673,93.673 s42.02,93.673,93.673,93.673S370.747,328.76,370.747,277.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a919f"
    },
    d: "M152.307,43.539c-51.2,0-94.19,35.62-105.632,83.459h41.438c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925H43.83c0,1.164-0.129,2.327-0.129,3.491c0,6.077,0.646,11.96,1.552,17.842h14.739 c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925h-8.921c14.545,37.042,48.743,64.129,89.729,68.461 c7.564-62.449,57.212-112.032,119.596-119.596C254.707,86.077,208.42,43.539,152.307,43.539z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M277.075,239.677c7.37,0,13.382,5.947,13.382,13.382c0,6.012,4.848,10.925,10.925,10.925 c6.012,0,10.925-4.848,10.925-10.925c0-15.515-10.214-28.832-24.242-33.358v-5.56c0-6.012-4.848-10.925-10.925-10.925 c-6.012,0-10.925,4.848-10.925,10.925v5.56c-14.093,4.655-24.242,17.842-24.242,33.358c0,19.394,15.774,35.168,35.168,35.168 c-0.323,0,0,0,0.065,0c6.723,0.711,13.317,6.271,13.317,13.188c0,7.37-5.947,13.382-13.382,13.382 c-7.37,0-13.382-5.947-13.382-13.382c0-6.012-4.848-10.925-10.925-10.925s-10.925,4.849-10.925,10.925 c0,15.515,10.214,28.832,24.242,33.358v5.56c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925v-5.56 c14.093-4.655,24.242-17.842,24.242-33.358c0-19.394-17.067-35.103-36.461-35.103c0.259,0,0.065,0-0.065,0 c-6.723-0.711-11.96-6.335-11.96-13.317C263.758,245.624,269.77,239.677,277.075,239.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M221.543,152.339c0-6.012-4.848-10.925-10.925-10.925h-47.321V60.283 c0-6.012-4.848-10.925-10.925-10.925s-10.925,4.848-10.925,10.925v92.057c0,6.012,4.848,10.925,10.925,10.925h58.246 C216.566,163.329,221.543,158.352,221.543,152.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M304.032,165.01c0.388-4.202,0.646-8.404,0.646-12.606c0-84.04-68.396-152.372-152.372-152.372 S0,68.364,0,152.339s68.331,152.307,152.307,152.307c4.202,0,8.404-0.323,12.606-0.646c12.218,50.683,57.794,88.566,112.226,88.566 c63.677,0,115.459-51.782,115.459-115.459C392.533,222.739,354.78,177.164,304.032,165.01z M161.875,282.408 c0,0.065-0.129,0.065-0.065,0.129c-3.168,0.259-6.335,0.323-9.438,0.323c-66.78,0-130.457-51.846-130.521-130.521 C22.368,86.4,74.602,21.818,152.307,21.818c71.952,0,130.521,58.57,130.521,130.521c0,3.168-0.065,6.335-0.323,9.438 c-0.065,0-0.129,0.065-0.259,0.065c-1.745-0.065-3.491-0.259-5.236-0.259c-63.677,0-115.459,51.782-115.459,115.459 C161.616,278.917,161.81,280.598,161.875,282.408z M277.075,370.78c-51.588,0-93.673-42.02-93.673-93.673 s42.02-93.673,93.673-93.673s93.673,42.02,93.673,93.673S328.727,370.78,277.075,370.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrrd);
export default __webpack_public_path__ + "static/media/prrd.cf1b185f85e67c0c534c815bbf056a2d.svg";
export { ForwardRef as ReactComponent };